// components
import SignInButton from '@/components/Navigation/SignInButton';
import PassportTransferFAQ from '@/components/passport/PassportTransferFAQ/PassportTransferFAQ';

// constants
import { PASSPORT_TRANSFER_NOT_SIGNED_IN_FAQ_BANK } from '@/components/passport/PassportTransferFAQ/PassportTransferFAQContent';

// styles
import styles from './PassportTransferSignedOut.module.scss';

export default function PassportTransferSignedOut() {
  return (
    <div className={styles.passport_transfer_signed_out}>
      <h1>Sign In With Your Passport Account</h1>
      <p className={styles.passport_transfer_signed_out__description}>
        To transfer your Passport access to a different email, first sign in with the email you currently use to access Passport.
      </p>
      <SignInButton style="white"/>
      <PassportTransferFAQ faqBank={PASSPORT_TRANSFER_NOT_SIGNED_IN_FAQ_BANK} />
    </div>
  )
}
